import React from "react";
import { ListPartner } from "components";
import { getTitleDecoration } from "utils/common";

const ModalCancelSuccess = ({ entry, closeFn, open }) => {
  return (
    <>
      {open && (
        <div className="modal active">
          <div className="modal-body">
            <div className="title text-black mt-2">
              案件をキャンセルしました
            </div>

            <div className="box p-2 p-md-3 my-3 text-start">
              <div>
                <div
                  className="d-block d-md-inline-block mb-1 mb-md-0"
                  dangerouslySetInnerHTML={{
                    __html: getTitleDecoration(
                      entry?.title_decoration?.title_decoration_content
                    ),
                  }}
                ></div>

                <span className="align-middle fs-14">{entry?.title_login}</span>
              </div>
              <ListPartner entry={entry} list={entry.partnerships} />
            </div>

            <div className="my-3 text-center">
              <div onClick={closeFn} className="btn-custom mt-2">
                閉じる
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalCancelSuccess;
